export { default as animationDurationInMS } from './duration';
export { default as animationEasingCurves } from './easing';
export { default as ReduceMotion } from './reduceMotion';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/animation/primitives/index.js
// module id = 1765
// module chunks = 12